import React,{useState} from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone,FiMail,FiMapPin,FiSend,FiCheck}=FiIcons;

function Contact() {
  const [formData,setFormData]=useState({
    name: '',
    email: '',
    phone: '',
    business: '',
    message: ''
  });
  const [isSubmitted,setIsSubmitted]=useState(false);
  const [isSubmitting,setIsSubmitting]=useState(false);

  const handleChange=(e)=> {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const encode=(data)=> {
    return Object.keys(data)
      .map(key=> encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  };

  const handleSubmit=(e)=> {
    e.preventDefault();
    setIsSubmitting(true);

    // Prepare form data for Netlify
    const formDataToSubmit={
      "form-name": "contact",
      ...formData
    };

    fetch("/",{
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
      body: encode(formDataToSubmit)
    })
      .then(()=> {
        setIsSubmitted(true);
        setIsSubmitting(false);
        // Reset form after showing success message
        setTimeout(()=> {
          setIsSubmitted(false);
          setFormData({
            name: '',
            email: '',
            phone: '',
            business: '',
            message: ''
          });
        },5000);
      })
      .catch((error)=> {
        console.error('Form submission error:',error);
        setIsSubmitting(false);
        alert('There was an error submitting your form. Please try again.');
      });
  };

  return (
    <div>
      {/* Contact Hero */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Get Your Strategy Call
          </h1>
          <div className="text-blue-100 mb-6">
            Connect with <span className="font-semibold text-white">AllGrowth by Handvantage</span>
          </div>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Ready to transform your marketing? Let's discuss how we can help you attract more leads,build trust,and grow your business.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Schedule Your Consultation
                </h2>
                <p className="text-lg text-gray-600">
                  Fill out the form below and we'll get back to you within 24 hours to schedule your strategy call with the AllGrowth team.
                </p>
              </div>

              {isSubmitted ? (
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                  <SafeIcon icon={FiCheck} className="h-12 w-12 text-green-500 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-green-800 mb-2">Thank You!</h3>
                  <p className="text-green-700">
                    We've received your message and will get back to you within 24 hours to schedule your strategy call.
                  </p>
                </div>
              ) : (
                <form
                  name="contact"
                  method="POST"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={handleSubmit}
                  className="space-y-6"
                >
                  {/* Hidden field for Netlify */}
                  <input type="hidden" name="form-name" value="contact" />
                  
                  {/* Honeypot field for spam protection */}
                  <div style={{display: 'none'}}>
                    <label>
                      Don't fill this out if you're human: <input name="bot-field" />
                    </label>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="John Smith"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="john@example.com"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="(555) 123-4567"
                      />
                    </div>
                    <div>
                      <label htmlFor="business" className="block text-sm font-medium text-gray-700 mb-2">
                        Business Name
                      </label>
                      <input
                        type="text"
                        id="business"
                        name="business"
                        value={formData.business}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="ABC Company"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Tell us about your business and marketing goals
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Tell us about your business,current marketing challenges,and what you'd like to achieve..."
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full px-6 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2 ${
                      isSubmitting
                        ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                  >
                    <SafeIcon icon={FiSend} className="h-5 w-5" />
                    <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
                  </button>
                </form>
              )}
            </div>

            {/* Contact Information */}
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Get In Touch</h2>
                <p className="text-lg text-gray-600">
                  Prefer to talk directly? Give us a call or send us an email. The AllGrowth team is here to help you grow your business.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 p-3 bg-blue-100 rounded-lg">
                    <SafeIcon icon={FiPhone} className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Phone</h3>
                    <a
                      href="tel:+12362350919"
                      className="text-blue-600 hover:text-blue-700 transition-colors"
                    >
                      +1 (236) 235-0919
                    </a>
                    <p className="text-sm text-gray-500 mt-1">
                      Monday - Friday,9am - 6pm PST
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 p-3 bg-blue-100 rounded-lg">
                    <SafeIcon icon={FiMail} className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Email</h3>
                    <a
                      href="mailto:info@handvantage.com"
                      className="text-blue-600 hover:text-blue-700 transition-colors"
                    >
                      info@handvantage.com
                    </a>
                    <p className="text-sm text-gray-500 mt-1">
                      We'll respond within 24 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 p-3 bg-blue-100 rounded-lg">
                    <SafeIcon icon={FiMapPin} className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Service Area</h3>
                    <p className="text-gray-600">
                      Serving local businesses across North America
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      Remote consultations available worldwide
                    </p>
                  </div>
                </div>
              </div>

              {/* What to Expect */}
              <div className="mt-12 p-6 bg-gray-50 rounded-xl">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  What to Expect on Your Strategy Call
                </h3>
                <ul className="space-y-3">
                  {[
                    'Analysis of your current marketing efforts',
                    'Identification of growth opportunities',
                    'Custom AllGrowth strategy recommendations',
                    'Discussion of our services and pricing',
                    'Next steps to get started'
                  ].map((item,index)=> (
                    <li key={index} className="flex items-start space-x-3">
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Handvantage Trust Badge */}
              <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="text-center">
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-900">AllGrowth</span> is a product of
                  </p>
                  <p className="text-lg font-bold text-blue-900">Handvantage Corporation</p>
                  <p className="text-xs text-gray-500 mt-1">
                    Trusted by 500+ businesses worldwide
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
          </div>
          <div className="space-y-8">
            {[
              {question: 'How long does it take to see results?',answer: 'Most clients start seeing increased website traffic within 30-60 days,with lead generation improving within 90 days. SEO results typically take 3-6 months for significant ranking improvements.'},
              {question: 'Do you work with businesses in my industry?',answer: 'We work with a wide variety of local businesses including contractors,professional services,healthcare providers,restaurants,and retail businesses. Our strategies are customized for each industry.'},
              {question: 'What makes AllGrowth different from other marketing agencies?',answer: 'AllGrowth is powered by Handvantage\'s enterprise-grade technology and focuses exclusively on local businesses. We use AI-powered content creation to deliver high-quality marketing at affordable prices with a done-for-you approach.'},
              {question: 'Can I cancel my service at any time?',answer: 'Yes,our services are month-to-month with no long-term contracts required. We believe in earning your business every month through results and exceptional service.'}
            ].map((faq,index)=> (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-600">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;